import { useEffect, useState } from "react";
import { ShieldCheck, Users } from "lucide-react";
import { api } from "@/lib/api";

export default function AdminOverviewTab() {
  const [stats, setStats] = useState(null);
  useEffect(() => { api.get("/admin/overview").then((r) => setStats(r.data)).catch(() => {}); }, []);

  if (!stats) return <p className="text-zinc-500 text-xs uppercase tracking-[0.25em] animate-pulse">Loading admin overview…</p>;
  const cards = [
    ["Members", stats.members], ["Active members", stats.active_members],
    ["Client records", stats.clients], ["Assessments", stats.assessments],
    ["Sessions", stats.sessions], ["Registrations", stats.registrations],
    ["Movements", stats.movements], ["Recorded revenue", `₹${stats.payments_recorded.toLocaleString("en-IN")}`],
  ];

  return (
    <div data-testid="admin-overview">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-zinc-800 border border-zinc-800">
        {cards.map(([label, value]) => (
          <div key={label} className="bg-zinc-950 p-6">
            <p className="font-display text-5xl leading-none text-volt">{value}</p>
            <p className="mt-2 text-[10px] uppercase tracking-[0.18em] text-zinc-500 font-bold">{label}</p>
          </div>
        ))}
      </div>
      <div className="grid md:grid-cols-2 gap-4 mt-4">
        <div className="border border-zinc-800 bg-zinc-950 p-6">
          <div className="flex items-center gap-3 mb-5"><Users className="text-volt" size={20} /><h3 className="font-display uppercase text-3xl">Credential accounts</h3></div>
          {Object.entries(stats.accounts).filter(([k]) => k !== "total_accounts").map(([label, value]) => (
            <div key={label} className="flex justify-between border-b border-zinc-800 py-3 text-sm">
              <span className="capitalize text-zinc-400">{label}</span><span className="font-display text-2xl text-volt">{value}</span>
            </div>
          ))}
        </div>
        <div className="border border-zinc-800 bg-zinc-950 p-6">
          <div className="flex items-center gap-3 mb-5"><ShieldCheck className="text-volt" size={20} /><h3 className="font-display uppercase text-3xl">Access model</h3></div>
          <p className="text-sm text-zinc-400 leading-relaxed">Member, coach and admin credentials are separated by portal. Admin email addresses are restricted by server configuration, and coach passwords can only be issued from this dashboard.</p>
        </div>
      </div>
    </div>
  );
}
